import { ReactElement, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { splitGamesIntoUnits } from './grid-utils';
import { isSmallerSelector } from '~/components/layout/mediaquery';
import { GridsContainer, Grid, CardContainer } from './grid.styles';

const cardsMap = {
	1: 'big',
	2: 'small',
	3: 'small',
	4: 'small',
	5: 'small',
	6: 'small',
	7: 'small',
	8: 'small',
	9: 'small',
	10: 'small',
	11: 'small'
} as const;

const cardPositions = {
	1: `
		grid-column: 1 / 3;
		grid-row: 1 / 3;
	`,
	2: `
		grid-column: 3 / 4;
		grid-row: 1;
	`,
	3: `
		grid-column: 4 / 5;
		grid-row: 1;
	`,
	4: `
		grid-column: 5 / 6;
		grid-row: 1;
	`,
	5: `
		grid-column: 6 / 7;
		grid-row: 1;
	`,
	6: `
		grid-column: 7 / 8;
		grid-row: 1;
	`,
	7: `
		grid-column: 3 / 4;
		grid-row: 2;
	`,
	8: `
		grid-column: 4 / 5;
		grid-row: 2;
	`,
	9: `
		grid-column: 5 / 6;
		grid-row: 2;
	`,
	10: `
		grid-column: 6 / 7;
		grid-row: 2;
	`,
	11: `
		grid-column: 7 / 8;
		grid-row: 2;
	`
};

type GridType2Props = {
	allowIncompleteUnits?: boolean;
};

const GridType2 = <T extends ReactElement<unknown>[]>({
	GameCards,
	allowIncompleteUnits = false
}: { GameCards: T } & GridType2Props) => {
	const isSmaller = useSelector(isSmallerSelector);

	const itemsPerUnit = 11;

	const units = useMemo(
		() => splitGamesIntoUnits(GameCards, itemsPerUnit, allowIncompleteUnits),
		[GameCards, itemsPerUnit, allowIncompleteUnits]
	);

	const gridSizes = useMemo(
		() => ({
			width: isSmaller ? '800px' : '1206px',
			height: isSmaller ? '220px' : '336px'
		}),
		[isSmaller]
	);

	const cardSizes = useMemo(
		() => ({
			big: {
				width: isSmaller ? '220px' : '336px',
				height: isSmaller ? '220px' : '336px'
			},
			small: {
				width: isSmaller ? '104px' : '162px',
				height: isSmaller ? '104px' : '162px'
			}
		}),
		[isSmaller]
	);

	return (
		<GridsContainer>
			{units.map((cards, unitIndex) => (
				<Grid
					// eslint-disable-next-line react/no-array-index-key
					key={`unit-${unitIndex}`}
					width={gridSizes.width}
					height={gridSizes.height}
				>
					{cards.map((card, cardIndex) => (
						<CardContainer
							key={card.key}
							size={cardSizes[cardsMap[(cardIndex + 1) as keyof typeof cardsMap]]}
							position={cardPositions[(cardIndex + 1) as keyof typeof cardPositions]}
						>
							{card}
						</CardContainer>
					))}
				</Grid>
			))}
		</GridsContainer>
	);
};

export default GridType2;
